import EBarMemberCenterCTA from './EBarMemberCenterCTA';

export default EBarMemberCenterCTA;
